<template>
    <div>
        <section class="jumbotron text-center">
            <div class="container">
                <h1 v-if="attendees" class="jumbotron-heading">Attendees for {{schedule_id}}</h1>
                <h1 v-else-if="registrants" class="jumbotron-heading">Registrants for {{schedule_id}}</h1>
                <h1 v-else-if="canceled" class="jumbotron-heading">Canceled registrations for {{schedule_id}}</h1>
                <h1 v-else class="jumbotron-heading">Guests</h1>
                <p class="lead text-muted">
                	<span style="font-weight: lighter">Event #id</span>
                	&nbsp;
                	<em>{{event_id}}</em></p>
                <p class="lead text-muted" v-for="f in filters" v-bind:key="f.id">
                	<span style="font-weight: lighter">{{f.name}}</span>
                	&nbsp;
                	<em>{{f.value}}</em>
                </p>
            </div>
        </section>

        <div class="ui container">
            <b-card-group>
                <b-card>
                    <h4>
                        Filters
                        <b-badge style="float: right">
                            <i class="fa fa-filter"></i>
                        </b-badge>
                    </h4>
                    <b-card-body>
                        <b-form-group>
                            <b-form-radio v-model="type" value="">All</b-form-radio>
                            <b-form-radio v-model="type" value="invitee">Invitees</b-form-radio>
                            <b-form-radio v-model="type" value="registrant">Registrants</b-form-radio>
                            <b-form-radio v-model="type" value="canceled">Canceled</b-form-radio>
                            <b-form-radio v-model="type" value="attendee">Attendees</b-form-radio>
                        </b-form-group>
                    </b-card-body>
                </b-card>
                <b-card>
                    <h4>
                        Partners
                        <b-badge style="float: right">
                            <i class="fa fa-users"></i>
                        </b-badge>
                    </h4>
                    <b-card-body>
                        <b-form-group>
                            <b-form-radio v-model="partners" value="yes">Fetch partners</b-form-radio>
                            <b-form-radio v-model="partners" value="no">Do not fetch partners</b-form-radio>
                            <b-form-radio v-model="partners" value="only">Fetch only partners</b-form-radio>
                        </b-form-group>
                    </b-card-body>
                </b-card>
            </b-card-group>
            
            <vuetable ref="vuetable"
                :http-fetch="fetchData"
                :api-mode="true"
                :api-url="apiUrl"
                :fields="listFields"
                
                pagination-path="pagination"
                data-path=""
                :http-options="httpOptions()"
                @vuetable:pagination-data="onPaginationData">
                <template slot="idslot" scope="props">
                    <div class="table-button-container">
                        <router-link :to="{name: 'guestDetails', params: {event_id: event_id, guest_id: props.rowData.id}}">{{props.rowData.id}}</router-link>
	                    &nbsp;
    	                <router-link v-if="couldBeAdded(props.rowData.status)" 
    	                	:to="{name: 'addGuestToSchedule', params: {event_id: event_id, schedule_id: schedule_id, external_id: props.rowData.code, type: 'attendee'}}">
			                <i class="fa fa-user-plus"></i>
			            </router-link>
			            &nbsp;
			            <router-link v-if="couldBeRemoved(props.rowData.status)" 
    	                	:to="{name: 'removeGuestFromSchedule', params: {event_id: event_id, schedule_id: schedule_id, external_id: props.rowData.code, type: 'attendee'}}">
			                <i class="fa fa-eraser"></i>
			            </router-link>
					</div>
                </template>
                <template slot="partnerslot" scope="props">
                    <b-link v-if="props.rowData.noOfPartners" @click="$data.partnersOf=props.rowData.id">
                    	<i class="fa fa-users"></i>
                    </b-link>
                </template>
            </vuetable>
            <vuetable-pagination
                ref="pagination" @vuetable-pagination:change-page="onChangePage">
            </vuetable-pagination>
        </div>
    </div>
</template>

<style>
.pagination a.item {
    padding: 10px;
}

.pagination a.item.large {
    font-weight: bolder
}
</style>


<script>
// import Vue from "vue";
import {Vuetable, VuetablePagination} from "vuetable-2";
import axios from "axios";

const RANGE_RGX = /^(?:items\s)?(\d+)-(\d+)\/(\d+)$/;

export default {
    name: "guestsList",
    props: [
    	"event_id",
    	"schedule_id",
    	"type",
    	"mode"
    ],
    components: {
        Vuetable,
        VuetablePagination
    },
    data() {
        return {
            partners: null,
            fields: [
                {
                    name: "__sequence",
                    title: "#",
                    titleClass: "center aligned",
                    dataClass: "right aligned"
                },
                {
                    name: "__slot:idslot",
                    title: "id"
                },
                {
                    name: "__slot:partnerslot",
                    title: "Partners"
                },
                {
                    name: "first_name",
                    title: "First name"
                },
                {
                    name: "last_name",
                    title: "Last name"
                },
                {
                    name: "email",
                    title: "Mail address"
                }],
            resources: {
                events: "/events",
                guests: "/guests",
                schedule: "/schedule",
                partners: "/partners"
            },
            page: 1,
            perPage: 10,
            pages: [],
            filters: [],
            partnersOf: null
        };
    },
    computed: {
        listFields() {
            return this.$data.fields;
        },
        apiUrl() {
        	let ret = this.$store.getters.apiBase + this.$data.resources.events + '/' + this.$props.event_id;
        	if (!this.$data.partnersOf && this.$props.schedule_id) {
        		ret += this.$data.resources.schedule + '/' + this.$props.schedule_id
        	}
        	
        	ret += this.$data.resources.guests;

			if (this.$data.partnersOf) {
        		ret += '/' + this.$data.partnersOf + this.$data.resources.partners
        	} else if (!this.$props.mode && this.$props.type) {
        		ret += "?type=" + this.$props.type;
        	}
        	console.debug("xxx", ret)
        	return ret;
        },
        attendees() {
        	return this.$props.type == "attendee";
        },
        registrants() {
        	return this.$props.type == "registrant";
        },
        canceled() {
        	return this.$props.type == "canceled";
        }
    },
    methods: {
        couldBeAdded(status) {
        	let couldBe = "add" == this.$props.mode && !!status;

        	if (couldBe) {
        		if (this.$props.type == "attendee") {
        			couldBe = !status.attended;
        		} else {
        			couldBe = false;
        		}
        	}

        	return couldBe; 
        },
        couldBeRemoved(status) {
        	let couldBe = "add" == this.$props.mode && !!status;

        	if (couldBe) {
        		if (this.$props.type == "attendee") {
        			couldBe = status.attended;
        		} else {
        			couldBe = false;
        		}
        	}

        	return couldBe; 
        },
        fetchData(resource, options) {
            if (options && options.hasOwnProperty("params")) {
                options.headers["Range"] = "items=" + (options.params.page - 1) * options.params.per_page + "-";
                options.headers["Range"] += (options.params.page - 1) * options.params.per_page + options.params.per_page - 1;
            }

            const currentPage = options.params.page;
            const perPage = options.params.per_page;

            delete options.params.page;
            delete options.params.per_page;

            if (!options.params.sort) {
                delete options.params.sort;
            }

            if (this.partners) {
                options.params.partners = this.partners;
            }
            return axios
                .get(resource, options)
                .then(response => {
                    try {
                        let m = RANGE_RGX[Symbol.match](
                            response.headers["content-range"]
                        );

						this.$data.filters.splice(0);
                        if (response.headers["x-eb-filters"]) {
                        	let i = 0;
                        	for (let f of response.headers["x-eb-filters"].split(", ")) {
                        		let parts = f.split(":");
                        		this.$data.filters.push({
                        			id: i++,
                        			name: parts[0].replace("_", " #"),
                        			value: parts[1]
                        		});
                        	}
                        	
                        	
                        }
                        const from = parseInt(m[1]);
                        const to = parseInt(m[2]);
                        const total = parseInt(m[3]);
                        if (!response.data) {
                        	response.data = {};
                        }
                        response.data.pagination = {
                            total: total,
                            per_page: perPage,
                            current_page: response.status == 204?undefined:currentPage,
                            last_page: Math.ceil(total / perPage),
                            from: from,
                            to: to
                        };
                        
                    } catch (err) {
                        console.debug(err);
                    }
                    return response;
                })
                .catch(error => {
                    console.log(error);
                });
        },

        httpOptions() {
            const _headers = {
                "Content-Type": "application/json",
                
                Authorization: this.$store.getters.accessToken,
                account_id: this.$store.getters.accountId
            };

            return {headers: _headers};
        },

        onPaginationData(paginationData) {
            this.$refs.pagination.setPaginationData(paginationData);
        },
        onChangePage(page) {
            this.$refs.vuetable.changePage(page);
        },
        editRow(rowData) {
            alert("You clicked edit on" + JSON.stringify(rowData));
        },
        deleteRow(rowData) {
            alert("You clicked delete on" + JSON.stringify(rowData));
        }
    },
    watch: {
        partners(old, value) {
            this.$refs.vuetable.refresh();
        }
    },
    created() {
        //this.fetchData();
    }
};
</script>